module.exports = __webpack_public_path__ + "media/images/emblems/Cremines-coat_of_arms-1a0a95b7cd2a2e82e0d54f2c3d40d856.svg";